import domReady from '@wordpress/dom-ready';
import Modules from './js/main';
import './scss/main.scss';
import _s from './js/components/helpers';

domReady(() => {
	Modules.forEach((Module) => {
		if (Module.moduleName === 'common') {
			Module.callScript();
		}
		if (
			document.body.contains(
				document.querySelector( '.' + Module.moduleName )
			)
		) {
			Module.callScript();
		}
		// if (document.body.classList.contains(Module.moduleName)) {
		// 	Module.callScript();
		// }
	});

	// _s('section').each(function () {
	// 	console.log(this)
	// })

	console.log(_s('.section-1').lastSibling());

});

